// Hide preloader on window load OR after 3 seconds (whichever comes first)
$(window).on("load", function() {
    "use strict";
    var preLoader = $('.loading');
    if (preLoader.length) {
        preLoader.fadeOut();
    }
});

// Fallback: Hide preloader after 3 seconds max to prevent infinite loading
$(document).ready(function() {
    "use strict";
    setTimeout(function() {
        var preLoader = $('.loading');
        if (preLoader.length && preLoader.is(':visible')) {
            preLoader.fadeOut();
        }
    }, 3000);
});